import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Button } from '@xingternal/button';

import reactDayPickerStyles from './reactDayPickerStyles.css';

const NavBar = ({ onPreviousClick, onNextClick }) => (
  <div className={reactDayPickerStyles.navWrapper}>
    <Button
      aria-label="Previous month"
      className={cx(reactDayPickerStyles.nav, reactDayPickerStyles.navLeft)}
      data-testid={'commbox-scheduling-calendar-prev-month'}
      onClick={() => {
        onPreviousClick();
      }}
      size="small"
    ></Button>
    <Button
      aria-label="Next month"
      className={cx(reactDayPickerStyles.nav, reactDayPickerStyles.navRight)}
      data-testid={'commbox-scheduling-calendar-next-month'}
      onClick={() => {
        onNextClick();
      }}
      size="small"
    ></Button>
  </div>
);

NavBar.propTypes = {
  className: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
};

export { NavBar };
